import MarketingLayout from "@/components/public/MarketingLayout";
import PublicBreadcrumb from "@/components/public/PublicBreadcrumb";
import { Button } from "@/components/ui/button";

export default function ContactPage() {
  return (
    <MarketingLayout>
      <section className="mx-auto max-w-5xl px-5 py-20 md:px-8">
        <div className="rounded-[34px] border border-slate-200 bg-white p-8 shadow-sm md:p-12">
          <PublicBreadcrumb currentLabel="Demo" />
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-sky-700">Demo e attivazione</div>
          <h1 className="mt-4 font-display text-5xl font-black text-slate-950">Parliamo del tuo modello di audit.</h1>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-600">
            Per attivazioni aziendali, piani studio o onboarding dedicato, usa questo punto di contatto come landing commerciale iniziale. Se vuoi, nel prossimo step posso collegarlo a un form reale o a un CRM.
          </p>
          <div className="mt-10 grid gap-6 md:grid-cols-3">
            <div className="rounded-3xl bg-slate-50 p-5">
              <div className="text-sm font-semibold text-slate-950">Cosa possiamo fare</div>
              <div className="mt-2 text-sm text-slate-600">Setup tenant, standardizzazione template, onboarding consulenti e team interni.</div>
            </div>
            <div className="rounded-3xl bg-slate-50 p-5">
              <div className="text-sm font-semibold text-slate-950">Flusso consigliato</div>
              <div className="mt-2 text-sm text-slate-600">Demo, scelta piano, attivazione Stripe o licenza enterprise, onboarding iniziale.</div>
            </div>
            <div className="rounded-3xl bg-slate-50 p-5">
              <div className="text-sm font-semibold text-slate-950">Contatto iniziale</div>
              <div className="mt-2 text-sm text-slate-600">sales@auditpro.local oppure integrazione futura con modulo lead e calendario.</div>
            </div>
          </div>
          <div className="mt-10">
            <Button asChild className="rounded-full bg-[#0f172a] px-6 hover:bg-slate-800">
              <a href="mailto:sales@auditpro.local">Scrivi al team</a>
            </Button>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
